import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#d73636',
    },
    secondary: {
      main: '#1976d2',
    },
    red: {
      main: '#FF0000'
    }
  },
});

export default theme;
